import ExtraAudio from "../ExtraAudio.js";

export default function MainButton({name, disabled=false, pending=false, onClick=()=>{}, className='', type="button"}) {
    return (
        <button 
            onClick={(e) => {
                ExtraAudio.sfxSample('click');
                onClick(e);
            }} 
            disabled={disabled} 
            className={`fango-main-button${(pending) ? ' pending' : '' } ${className}`}
            type={type}
        >
            <div className="positioner">
                {(pending) ? '...' : name}
            </div>
        </button>
    );
}